module.exports = __webpack_public_path__ + "img/vannkraft_smvf.73592647.jpg";